import { NonterminalKind } from '@nomicfoundation/slang/cst';
import { extractVariant } from '../slang-utils/extract-variant.js';
import { SlangNode } from './SlangNode.js';
import { MappingKeyType } from './MappingKeyType.js';
import { TerminalNode } from './TerminalNode.js';

import type * as ast from '@nomicfoundation/slang/ast';
import type { Doc } from 'prettier';
import type { CollectedMetadata, PrintFunction } from '../types.d.ts';

export class MappingKey extends SlangNode {
  readonly kind = NonterminalKind.MappingKey;

  keyType: MappingKeyType['variant'];

  name?: TerminalNode;

  constructor(ast: ast.MappingKey, collected: CollectedMetadata) {
    super(ast, collected);

    this.keyType = extractVariant(new MappingKeyType(ast.keyType, collected));
    if (ast.name) {
      this.name = new TerminalNode(ast.name, collected);
    }

    this.updateMetadata(this.keyType);
  }

  print(print: PrintFunction): Doc {
    const nameDoc = print('name');
    return [print('keyType'), nameDoc ? [' ', nameDoc] : nameDoc];
  }
}
